<template>
  <div class="horizontal-list">
    <h2 class="mx-4">{{ title }}</h2>
    <swiper
      :modules="modules"
      navigation
      :slides-per-view="slidesPerView"
      :space-between="5"
      :pagination="showNavigation ? { clickable: true } : false"
      :scrollbar="showNavigation ? { draggable: true } : false"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="(asset, i) in assets" v-bind:key="i">
        <horizontal-card-clean :asset="asset" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import HorizontalCard from "@/components/landing/carousel/HorizontalCard.vue";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper";
import HorizontalCardClean from "@/components/landing/carousel/HorizontalCardClean.vue";

export default {
  name: "HorizontalCarousel",
  components: {
    HorizontalCardClean,
    HorizontalCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    assets: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    show_navigation: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showNavigation() {
      if (this.isMobile()) {
        return false;
      }
      return this.show_navigation;
    },
    slidesPerView() {
      if (this.isMobile()) {
        return 1.3;
      } else {
        return 4.3;
      }
    },
  },

  methods: {
    onSwiper(swiper) {},
    onSlideChange() {},
    onSwiperReachEnd(swiper) {},
  },
  setup() {
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
};
</script>

<style lang="scss">
.horizontal-list {
  h2 {
    margin: 0;
  }
  .swiper-button-next,
  .swiper-button-prev {
    top: 40%;
    transform: translateY(-50%);
  }
}
</style>
